import { render, staticRenderFns } from "./SettingSite.vue?vue&type=template&id=e4ccfaac"
import script from "./SettingSite.vue?vue&type=script&lang=js"
export * from "./SettingSite.vue?vue&type=script&lang=js"
import style0 from "./SettingSite.vue?vue&type=style&index=0&id=e4ccfaac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports